<template>
	<div>
		<apexchart
				width="100%"
				type="bar"
				:height="height || '100%'"
				:options="chartOptions"
				:series="series"
		></apexchart>
	</div>
</template>

<script>
	export default {
		name: "apexbar",
		props: [
			"categories",
			"barColor",
			"barColors",
			"height",
		],
		data() {
			return {
				series: [{
					data: this.categories.value
				}],
				chartOptions: {
					chart: {
						type: 'bar',
						events: {
							click: function (chart, w, e) {
							}
						},
						toolbar: {
							show: false,
						}
					},
					colors: this.barColors,
					fill: {
						colors: this.barColors
					},
					plotOptions: {
						bar: {
							columnWidth: '80%',
							distributed: true,
							dataLabels: {
								position: 'top',
							},
						}
					},
					dataLabels: {
						enabled: true,
						formatter: function (val, opt) {
							return (isNaN(val) ? 0 : val) + '%';
						},
						offsetY: -2,
						style: {
							fontSize: '12px',
							fontWeight: 400,
							fontFamily: 'Poppins, sans-serif',
							colors: this.categories.color
						}
					},
					legend: {
						show: false
					},
					xaxis: {
						categories: this.categories.name,
						labels: {
							style: {
								colors: this.barColor,
								fontSize: '14px',
								fontWeight: 400,
							}
						}
					},
					yaxis: {
						labels: {
							style: {
								fontSize: '14px',
								fontWeight: 400,
								cssClass: 'apexcharts-yaxis-label',
							},
							offsetY: 5,
						},
					},
					tooltip: {
						x: {
							show: false
						},
						y: {
							formatter: function(val) {
								return (isNaN(val) ? 0 : val) + "%"
							},
							title: {
								formatter: function (seriesName) {
									return ''
								}
							}
						}
					}
				},
			};
		},
		mounted() {
		},
		methods: {}
	};
</script>

<style scoped>
</style>
